export default {"src":"/_next/static/media/appstore.a05cad9b.svg","height":40,"width":146,"blurWidth":0,"blurHeight":0};